import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BACKEND } from "@/lib/api";

const CodeBlock = ({ code, testId }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    toast.success("Embed-koden er kopiert");
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className="relative">
      <pre className="bg-[#0A192F] text-sky-100 text-xs sm:text-[13px] leading-relaxed rounded-md p-4 pr-14 overflow-x-auto whitespace-pre-wrap break-all font-num" data-testid={testId}>
        {code}
      </pre>
      <Button size="sm" variant="secondary" onClick={copy} className="absolute top-2 right-2" data-testid={`${testId}-copy`}>
        {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
      </Button>
    </div>
  );
};

export const EmbedCode = ({ cid }) => {
  const script = `<div class="havnekalkulator" data-kalkulator="${cid}"></div>\n<script src="${BACKEND}/api/embed/loader.js" async></script>`;
  const iframe = `<iframe src="${BACKEND}/api/embed/${cid}" title="Havnekalkulator" style="width:100%;height:640px;border:0;" loading="lazy"></iframe>`;
  return (
    <Tabs defaultValue="script" className="w-full" data-testid="embed-code">
      <TabsList>
        <TabsTrigger value="script" data-testid="embed-tab-script">Anbefalt</TabsTrigger>
        <TabsTrigger value="iframe" data-testid="embed-tab-iframe">Kun iframe</TabsTrigger>
      </TabsList>
      <TabsContent value="script" className="space-y-3">
        <CodeBlock code={script} testId="embed-code-script" />
        <p className="text-sm text-slate-600 leading-relaxed">
          I WordPress/Elementor Pro: dra inn widgeten <strong>HTML</strong> der kalkulatoren skal stå, og lim inn koden.
          Høyden tilpasses automatisk på mobil, nettbrett og PC.
        </p>
      </TabsContent>
      <TabsContent value="iframe" className="space-y-3">
        <CodeBlock code={iframe} testId="embed-code-iframe" />
        <p className="text-sm text-slate-600">Brukes der script ikke er tillatt. Høyden er fast og kan justeres i koden.</p>
      </TabsContent>
    </Tabs>
  );
};
